<div class="menu-row">
  <mode-labeled-menu
    data-test="thousands-separator-menu"
    class="menu-cell"
    label="Thousands separator"
    menuClass="percent-format-pane-menu"
    [selected]="selectedThousandsSeparator"
    [menuItems]="thousandsSeparatorMenuItems"
    (menuChange)="onChangeSeparator($event)"
  ></mode-labeled-menu>
  <mode-labeled-menu
    data-test="thousands-grouping-menu"
    class="menu-cell"
    label="Thousands grouping"
    menuClass="percent-format-pane-menu"
    [selected]="selectedThousandsGrouping"
    [menuItems]="thousandsGroupingMenuItems"
    (menuChange)="onChangeGrouping($event)"
  ></mode-labeled-menu>
</div>

<div class="menu-row">
  <mode-labeled-menu
    data-test="decimal-separator-menu"
    class="menu-cell"
    label="Decimal symbol"
    menuClass="percent-format-pane-menu"
    [selected]="selectedDecimalSymbol"
    [menuItems]="decimalSymbolMenuItems"
    (menuChange)="onChangeSymbol($event)"
  ></mode-labeled-menu>
  <div class="menu-cell">
    <label class="form-control-label">Decimal places</label>
    <input
      data-test="decimal-precision"
      [ngModel]="format.precision"
      (ngModelChange)="onChangePrecision($event)"
      placeholder="Auto"
      class="form-control form-control-sm precision"
      type="number"
      step="1"
      max="12"
      min="0"
    />
    <div class="subtext">Between 0-12</div>
  </div>
</div>

<div class="menu-row">
  <div class="transform-wrapper">
    <label for="formatPanePercentTransform">
      <capra-icon icon="icon-check" [class.selected]="format.percentTransform"></capra-icon>
      <input
        data-test="percent-transform"
        id="formatPanePercentTransform"
        type="checkbox"
        tabindex="0"
        [value]="format.percentTransform"
        [checked]="format.percentTransform"
        [ngModel]="format.percentTransform"
        (ngModelChange)="
          apply({
            percentTransform: !!$event
          })
        "
      />
      <span>Multiply the values returned in the column by 100</span>
    </label>
  </div>
</div>
